import numeral from 'numeral';

export const formatCurrency = (value?: number | string | null) => {
  if (typeof value === 'undefined' || value === null) {
    return value;
  }

  return numeral(Number(value)).format('0,0.[00]');
};
